import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SelectOutlinedSvg from "@ant-design/icons-svg/es/asn/SelectOutlined";
import AntdIcon from "../components/AntdIcon";
var SelectOutlined = function SelectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SelectOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SelectOutlined.displayName = 'SelectOutlined';
}
export default /*#__PURE__*/React.forwardRef(SelectOutlined);